module.exports = __webpack_public_path__ + "images/select2x2.png";